import { z } from 'zod';

export const generateCampaignScheduleSchema = z.object({
  startTime: z.number(),
  endTime: z.number(),
  numOfAdGroups: z.number(),
});
export type GenerateCampaignScheduleDTO = z.infer<
  typeof generateCampaignScheduleSchema
>;

export type CampaignScheduleIntervalType = 'week' | 'day';

export interface CampaignSchedule {
  startTime: number;
  endTime: number;
  numOfAdGroups: number;
  adjustmentTimestamps: number[];
  interval: number;
  intervalType: CampaignScheduleIntervalType;
  intervalTotal: number;
}
